import './new-transaction.scss';

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormTransaction from "../form-transaction/form-transaction";
import { useNewTransaction } from './new-transaction.hook';

export function NewTransaction() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewTransaction();

  return (
    <div id="NewTransaction" className="transaction">
      <HeaderContent
        title={<h1>New Transaction</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormTransaction />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewTransaction;